<template>
  <div>
    <interaction-hint v-if="!readonly">
      Выберите все правильные варианты (и только их)
    </interaction-hint>
    <v-checkbox
      v-for="(item, index) in optionsList"
      :key="index"
      class="answer"
      :label="item.index + ' ' + item.option"
      :input-value="item.checked"
      :disabled="readonly"
      hide-details
      @change="answer(index + 1, !item.checked)"
    />
  </div>
</template>
<script type="text/babel">
import InteractionHint from './InteractionHint'
export default {
  name: 'InteractionMOfN',
  props: {
    items: {
      type: [Array, Object],
      required: true
    },
    value: {
      required: true
    },
    readonly: {
      default: false
    }
  },
  computed: {
    checks() {
      if (this.value) {
        return String(this.value)
          .split(',')
          .map(e => Number(e))
      } else {
        return []
      }
    },
    optionsList() {
      if (Array.isArray(this.items)) {
        return this.items.map((e, index) => {
          const c = { ...e }
          c.checked = this.checks.includes(index + 1)
          return c
        })
      } else {
        return []
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.keyDown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyDown)
  },
  methods: {
    keyDown(event) {
      switch (event.code) {
        case 'Digit1':
        case 'Digit2':
        case 'Digit3':
        case 'Digit4':
        case 'Digit5':
        case 'Digit6':
        case 'Digit7':
        case 'Digit8':
        case 'Digit9':
          this.toggle(Number(event.code.slice(-1)))
          break
      }
    },
    toggle(index) {
      this.answer(index, !this.checks.includes(Number(index)))
    },
    answer(index, value) {
      const checks = this.checks.filter(e => e !== index)
      if (value) {
        checks.push(index)
      }
      const retval = checks.sort().join(',')
      this.$emit('input', retval)
    }
  },
  components: {
    InteractionHint
  }
}
</script>
